import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initMonitoring } from "@/lib/monitoring";

// App version for debugging
const APP_VERSION = import.meta.env.VITE_APP_VERSION || new Date().toISOString().slice(0, 16);
console.log(`📱 GOnX v${APP_VERSION}`);

// Inicializar Sentry ANTES de qualquer renderização React, para capturar
// erros de inicialização do bundle (importações falhas, scripts quebrados).
initMonitoring();

// Auto-reload on stale chunk errors (post-deploy cache mismatch)
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

// Note: Service Worker registration is now handled by VitePWA plugin
// The useServiceWorkerUpdate hook manages updates via virtual:pwa-register/react

createRoot(document.getElementById("root")!).render(
  <App />
);
